import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { MatDialog } from '@angular/material';
import { ModalAddActividadComponent } from '../modal-add-actividad/modal-add-actividad.component';
import { ModalAddIngresosGastosActividadesComponent } from '../modal-add-ingresos-gastos-actividades/modal-add-ingresos-gastos-actividades.component';

@Component({
  templateUrl: './AccionesAddEntidades.component.html'
})
export class AccionesAddEntidadesComponent implements ViewCell, OnInit {

  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  constructor(public dialog: MatDialog) {
   
  }

  ngOnInit() {

  }
  openDialog(): void {
    let dialogRef = this.dialog.open(ModalAddIngresosGastosActividadesComponent, {
      panelClass: 'custom-dialog',
      data: {
        contenido: this.rowData
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

}
